const B_1 = [
    {
        title: '中标候选人公示审核',
        path: '/manage/business/auditzbhxrgs/list'
    }
]

export default {
    path: 'auditzbhxrgs',
    component: () => import(/*webpackChunkName: 'business-auditzbhxrgs'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/manage/views/business/audit-zbhxrgs/list'),
            meta: {
                title: '中标候选人公示审核',
                topNav: true,
                bread: B_1
            },
        }
    ]
}
